import styles from '~/styles/pages/info-icons.module.scss';
import Spacer from '~/components/spacer';

export default function InfoIconContent(props: { title: string; content: string[]; icon: JSX.Element }) {
  return (
    <div className={styles['icon-card']}>
      {props.icon}
      <Spacer />
      <h1 className={styles['icon-card-title']}>{props.title}</h1>
      <Spacer />
      <p>{props.content}</p>
    </div>
  );
}
